export function diffSources(prevStyle, nextStyle) {
  var prevSources = prevStyle.get("sources"),
      nextSources = nextStyle.get("sources"),
      enter = [],
      update = [],
      exit = [],
      prevIds = prevSources.keySeq().toArray(),
      nextIds = nextSources.keySeq().toArray(),
      _iteratorNormalCompletion = !0,
      _didIteratorError = !1,
      _iteratorError = void 0;

  try {
    for (var _step, _iterator = prevIds[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = !0) {
      var id = _step.value,
          nextSource = nextSources.get(id);
      nextSource ? !nextSource.equals(prevSources.get(id)) && update.push({
        id: id,
        source: nextSources.get(id)
      }) : exit.push({
        id: id,
        source: prevSources.get(id)
      });
    }
  } catch (err) {
    _didIteratorError = !0, _iteratorError = err;
  } finally {
    try {
      _iteratorNormalCompletion || null == _iterator.return || _iterator.return();
    } finally {
      if (_didIteratorError) throw _iteratorError;
    }
  }

  var _iteratorNormalCompletion2 = !0,
      _didIteratorError2 = !1,
      _iteratorError2 = void 0;

  try {
    for (var _step2, _iterator2 = nextIds[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = !0) {
      var _id = _step2.value,
          prevSource = prevSources.get(_id);
      prevSource || enter.push({
        id: _id,
        source: nextSources.get(_id)
      });
    }
  } catch (err) {
    _didIteratorError2 = !0, _iteratorError2 = err;
  } finally {
    try {
      _iteratorNormalCompletion2 || null == _iterator2.return || _iterator2.return();
    } finally {
      if (_didIteratorError2) throw _iteratorError2;
    }
  }

  return {
    enter: enter,
    update: update,
    exit: exit
  };
}
export function diffLayers(prevStyle, nextStyle) {
  var prevLayers = prevStyle.get("layers"),
      nextLayers = nextStyle.get("layers"),
      updates = [],
      exiting = [],
      prevMap = {},
      nextMap = {};
  nextLayers.forEach(function (layer, index) {
    var id = layer.get("id"),
        layerImBehind = nextLayers.get(index + 1);
    nextMap[id] = {
      layer: layer,
      id: id,
      before: layerImBehind ? layerImBehind.get("id") : null,
      enter: !0
    };
  }), prevLayers.forEach(function (layer, index) {
    var id = layer.get("id"),
        layerImBehind = prevLayers.get(index + 1);
    prevMap[id] = {
      layer: layer,
      id: id,
      before: layerImBehind ? layerImBehind.get("id") : null
    }, nextMap[id] ? nextMap[id].enter = !1 : exiting.push(prevMap[id]);
  });

  var _iteratorNormalCompletion3 = !0,
      _didIteratorError3 = !1,
      _iteratorError3 = void 0;

  try {
    for (var _step3, _iterator3 = nextLayers.reverse()[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = !0) {
      var layer = _step3.value,
          id = layer.get("id");
      prevMap[id] && prevMap[id].layer.equals(nextMap[id].layer) && prevMap[id].before === nextMap[id].before || updates.push(nextMap[id]);
    }
  } catch (err) {
    _didIteratorError3 = !0, _iteratorError3 = err;
  } finally {
    try {
      _iteratorNormalCompletion3 || null == _iterator3.return || _iterator3.return();
    } finally {
      if (_didIteratorError3) throw _iteratorError3;
    }
  }

  return {
    updates: updates,
    exiting: exiting
  };
}
export default function diffStyle(prevStyle, nextStyle) {
  return {
    sourcesDiff: diffSources(prevStyle, nextStyle),
    layersDiff: diffLayers(prevStyle, nextStyle)
  };
}